// components/Modal/ConfirmModal/index.tsx
import React from 'react';
import styles from './styles.module.scss';

interface Props {
  title: string;
  description: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function ConfirmModal({ title, description, onConfirm, onCancel }: Props) {
  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <h3>{title}</h3>
        <p>{description}</p>
        <div className={styles.buttons}>
          <button onClick={onCancel}>Отмена</button>
          <button className={styles.confirm} onClick={onConfirm}>Подтвердить</button>
        </div>
      </div>
    </div>
  );
}
